

export function enableSnowplowPlugins() {
    enableSnowplowButtonClickTracking();
    enableSnowplowLinkClickTracking();
    enableSnowplowMediaTracking();
}


export function enableSnowplowButtonClickTracking() {
    window.snowplow(
        'addPlugin',
        'https://cdn.jsdelivr.net/npm/@snowplow/browser-plugin-button-click-tracking@latest/dist/index.umd.min.js',
        ['snowplowButtonClickTracking', 'ButtonClickTrackingPlugin']
    );

    window.snowplow('enableButtonClickTracking');
}

export function enableSnowplowLinkClickTracking() {
    window.snowplow('addPlugin',
        "https://cdn.jsdelivr.net/npm/@snowplow/browser-plugin-link-click-tracking@latest/dist/index.umd.min.js",
        ["snowplowLinkClickTracking", "LinkClickTrackingPlugin"]
    );

    window.snowplow('enableLinkClickTracking', { pseudoClicks: true });
}

export function enableSnowplowMediaTracking() {
    window.snowplow(
        'addPlugin',
        'https://cdn.jsdelivr.net/npm/@snowplow/browser-plugin-media@latest/dist/index.umd.min.js',
        ['snowplowMedia', 'SnowplowMediaPlugin']
    );
}


